document.addEventListener('DOMContentLoaded', () => {
  if (customElements.get('new-common-feature-cards')) return;

  class NewCommonFeatureCards extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'region');
      if (!this.getAttribute('aria-label') && !this.querySelector('[id$="-heading"]')) {
        this.setAttribute('aria-label', 'Feature cards');
      }

      if (this.dataset.enableMbSwiper !== 'true') return;

      const swiperEl = this.querySelector('.ncfc__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      const slidesPerView = Number(this.dataset.swiperMbNum) || 1;
      const spaceBetween = Number(this.dataset.swiperMbGap) || 20;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView,
        spaceBetween,
        watchOverflow: true,
        pagination: this.querySelector('.ncfc__pagination')
          ? { el: this.querySelector('.ncfc__pagination'), clickable: true }
          : undefined,
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('new-common-feature-cards', NewCommonFeatureCards);
});
